module.exports = __webpack_public_path__ + "img/liuchengjiandan.53c95e3a.png";